import { assetIds, RichTextfield } from "nemuru-components";
import React, { useEffect } from "react";
import { ICON_TITLE_HEIGHT } from "../../../../../config/config";
import { Typography, useTheme } from "@material-ui/core";
import { Controller, useForm } from "react-hook-form";
import { Box } from "@material-ui/core";
import IconTitle from "../../../../shared/components/IconTitle";
import Text from "../../../../shared/components/Text";
import { ThemedAsset } from "nemuru-components";
import MainButton from "../../../../shared/components/MainButton";
import { useToggleButtonStyles } from "../../../kyc/shared/AdditionalData/steps/AdditionalDataFamilyForm";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { parseStringAmountWithUnitToNumber } from "../../../../../utils/formaters";

export const CUSTOM_FIXED_INSTALMENT_AMOUNT = "custom_fixed_instalment_amount";

export const FIXED_INSTALMENT_AMOUNT_OPTIONS = [
  {
    value: "20",
    label: "20,00 €",
  },
  {
    value: "40",
    label: "40,00 €",
  },
  {
    value: CUSTOM_FIXED_INSTALMENT_AMOUNT,
    label: (
      <Typography variant="subtitle2">
        <Text tId="OTHER_AMOUNT" />
      </Typography>
    ),
  },
];

export const FixedInstalmentAmount = ({ onSubmitForm, data }) => {
  const { palette, shape } = useTheme();
  const {
    getValues,
    handleSubmit,
    control,
    watch,
    register,
    errors,
    setValue,
  } = useForm({
    defaultValues: {
      fixedInstalmentAmount: data?.fixedInstalmentAmount,
      customFixedInstalmentAmount: data?.customFixedInstalmentAmount,
    },
  });

  const classes = useToggleButtonStyles(3)();

  const fixedInstalmentAmountWatcher =
    watch("fixedInstalmentAmount") ?? data?.fixedInstalmentAmount;

  useEffect(() => {
    if (fixedInstalmentAmountWatcher !== CUSTOM_FIXED_INSTALMENT_AMOUNT) {
      setValue("customFixedInstalmentAmount", undefined);
    }
  }, [fixedInstalmentAmountWatcher]);

  return (
    <>
      <Box>
        <IconTitle
          icon={
            <ThemedAsset
              id={assetIds.ICON_MONEY}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId="FIXED_INSTALMENT_AMOUNT" />}
          subtitle={<Text tId="FIXED_INSTALMENT_AMOUNT_SUBTITLE" />}
        />
        <Box>
          <Typography variant="subtitle1" color={"textPrimary"}>
            <Text strong tId={"SELECT_FIXED_INSTALMENT_AMOUNT"} />
          </Typography>
          <Box
            mt={2}
            mb={1}
            display={"flex"}
            flexDirection={"column"}
            gridGap={8}
            alignItems={"end"}
          >
            <Controller
              name="fixedInstalmentAmount"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: <Text tId={"REQUIRED_FIELD"} />,
                },
              }}
              render={(props) => (
                <>
                  <ToggleButtonGroup
                    style={{
                      width: "100%",
                      borderRadius: shape.borderRadius,
                    }}
                    value={
                      watch("fixedInstalmentAmount") ??
                      data?.fixedInstalmentAmount
                    }
                    onChange={(e) => props.onChange(e.target.value)}
                    exclusive
                    aria-label="text alignment"
                  >
                    {FIXED_INSTALMENT_AMOUNT_OPTIONS.map((option) => (
                      <ToggleButton
                        value={option.value}
                        classes={{
                          root: classes.toggleButtonroot,
                          selected: classes.toggleButtonselected,
                        }}
                      >
                        <div style={{ pointerEvents: "none" }}>
                          {option.label}
                        </div>
                      </ToggleButton>
                    ))}
                  </ToggleButtonGroup>
                  {fixedInstalmentAmountWatcher ===
                    CUSTOM_FIXED_INSTALMENT_AMOUNT && (
                    <Box mt={1} mb={2} maxWidth={"33%"}>
                      <RichTextfield
                        defaultValue={parseStringAmountWithUnitToNumber(
                          data?.customFixedInstalmentAmount
                        )}
                        autoFocus
                        allowDecimals
                        hideIcon
                        unitName={"€"}
                        fullWidth
                        label={
                          <Box overflow={"hidden"} whiteSpace={"nowrap"}>
                            <Text tId={"MONTHLY_AMOUNT"} />
                          </Box>
                        }
                        id="customFixedInstalmentAmount"
                        name="customFixedInstalmentAmount"
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                          ref: register({
                            required: {
                              value: true,
                              message: <Text tId={"REQUIRED_FIELD"} />,
                            },
                            validate: {
                              validate: (value) => {
                                const maxAmount = 100; // TODO: change max amount when we have the real value
                                const repaymentAmount =
                                  parseStringAmountWithUnitToNumber(value);
                                if (repaymentAmount > maxAmount) {
                                  return (
                                    <Text
                                      tId={"REPAYMENT_AMOUNT_GREATER_THAN_MAX"}
                                      dynamicDataTexts={[maxAmount]}
                                    />
                                  );
                                }
                              },
                            },
                          }),
                        }}
                        error={
                          errors.customFixedInstalmentAmount ? true : false
                        }
                        helperText={errors.customFixedInstalmentAmount?.message}
                      />
                    </Box>
                  )}
                </>
              )}
            />
          </Box>
        </Box>
      </Box>
      <Box display="flex" flexDirection="column" gridGap={8}>
        <Typography variant="caption">
          <Text tId="FIXED_INSTALMENT_INFORMATION_DESCRIPTION" />
        </Typography>
        <MainButton onClick={handleSubmit(() => onSubmitForm(getValues()))} />
      </Box>
    </>
  );
};
